(function () {
  'use strict';

  /* ============================================================
     Carta Noor style quiz — the single implementation.
     Rebuilt 28 Aug 2026.

     HISTORY, so nobody rebuilds the old one:
     The theme carried TWO quizzes. This file's #cnQuizOverlay, and
     a second one inside assets/theme.js rendering into #cnQuizModal
     / #cnQuizInner. Both opened; theme.js's sat at z-index 600
     opacity 1 and this one at 9999 opacity 0, so visitors only ever
     used theme.js's. That one scored over a hardcoded
     FALLBACK_PRODUCTS list and only attached a real image when a
     handle matched the live catalogue — and the handles had gone
     stale, so every card fell through to a text placeholder. That
     was the "quiz results show no product image" bug.

     #cnQuizModal has been deleted from layout/theme.liquid, which
     disables theme.js's quiz (it guards on `quizModal && (...)`,
     wireQuizTriggers() included) and frees the header
     "Find My Style" buttons for this file to bind.

     Products come from #CNQuizData, rendered server-side by
     snippets/cn-quiz-modal.liquid. No API token, no Storefront
     call, no products.json fetch. Matching runs on each product's
     OWN TAGS, so a newly tagged product is matched automatically.

     No backslashes anywhere in this file — it is deployed through
     a GraphQL block string, which passes backslashes through
     literally and has silently broken regexes here before.
     ============================================================ */

  var cfg = window.cnQuizConfig || {};
  var RESULT_COUNT = cfg.resultCount || 3;
  var WEIGHTS = { palette: 3, style: 3, mood: 2, space: 2 };
  var MODE_BONUS = 2;
  var BATHROOM_NOTE = cfg.bathroomNote ||
    'A note on bathrooms: our non-woven papers are rated for dry rooms. On a bathroom wall, choose one away from direct splash and make sure the room ventilates well.';

  var state = {
    currentStep: 1,
    totalSteps: 4,
    answers: { space: null, palette: null, mood: null, style: null },
    tagSets: { space: [], palette: [], mood: [], style: [] },
    wantMode: ''
  };

  var overlay     = document.getElementById('cnQuizOverlay');
  var closeBtn    = document.getElementById('cnQuizClose');
  var progressBar = document.getElementById('cnQuizProgressBar');

  // On-page results (only where sections/quiz-cta.liquid is used)
  var resultsEl  = document.getElementById('cnQuizResults');
  var gridEl     = document.getElementById('cnQuizGrid');
  var advisoryEl = document.getElementById('cnQuizAdvisory');
  var retakeBtn  = document.getElementById('cnQuizRetake');

  // In-modal results (every other page)
  var modalGrid     = document.getElementById('cnQuizModalGrid');
  var modalAdvisory = document.getElementById('cnQuizModalAdvisory');
  var modalRetake   = document.getElementById('cnQuizModalRetake');

  if (!overlay) { return; }

  // ---- product data -------------------------------------------------------
  var PRODUCTS = [];
  (function loadData() {
    var el = document.getElementById('CNQuizData');
    if (!el) { return; }
    try {
      var parsed = JSON.parse(el.textContent || '[]');
      if (Object.prototype.toString.call(parsed) === '[object Array]') {
        PRODUCTS = parsed;
      }
    } catch (e) {
      PRODUCTS = [];
    }
  })();

  function tagList(product) {
    return String(product.g || '').split('|').map(function (t) {
      return t.trim().toLowerCase();
    }).filter(Boolean);
  }

  // ---- open / close -------------------------------------------------------
  function openQuiz() {
    resetQuiz();
    overlay.removeAttribute('aria-hidden');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeQuiz() {
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function resetQuiz() {
    state.currentStep = 1;
    state.answers = { space: null, palette: null, mood: null, style: null };
    state.tagSets = { space: [], palette: [], mood: [], style: [] };
    state.wantMode = '';
    showStep(1);
    updateProgress(1);
    var opts = document.querySelectorAll('.cn-quiz-option');
    for (var i = 0; i < opts.length; i++) { opts[i].classList.remove('is-selected'); }
  }

  // Every entry point, including the header buttons theme.js used to own.
  var openerIds = ['cnQuizOpenSection', 'cnQuizOpen', 'cnQuizOpenMobile'];
  for (var o = 0; o < openerIds.length; o++) {
    var opener = document.getElementById(openerIds[o]);
    if (opener) {
      opener.addEventListener('click', function (e) {
        e.preventDefault();
        openQuiz();
      });
    }
  }
  // Anything else that asks for the quiz by attribute.
  var extraOpeners = document.querySelectorAll('[data-cn-quiz-open]');
  for (var x = 0; x < extraOpeners.length; x++) {
    extraOpeners[x].addEventListener('click', function (e) {
      e.preventDefault();
      openQuiz();
    });
  }

  if (closeBtn)    { closeBtn.addEventListener('click', closeQuiz); }
  if (retakeBtn)   { retakeBtn.addEventListener('click', openQuiz); }
  if (modalRetake) { modalRetake.addEventListener('click', openQuiz); }

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) { closeQuiz(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeQuiz(); }
  });

  // Legacy hooks: theme.js exposed these globally.
  window.openQuiz = openQuiz;
  window.closeQuiz = closeQuiz;

  // ---- steps --------------------------------------------------------------
  function showStep(step) {
    var steps = document.querySelectorAll('.cn-quiz-step');
    for (var i = 0; i < steps.length; i++) { steps[i].classList.remove('is-active'); }
    var target = document.querySelector('.cn-quiz-step[data-step="' + step + '"]');
    if (target) { target.classList.add('is-active'); }
  }

  function updateProgress(step) {
    var pct = ((step - 1) / state.totalSteps) * 100;
    if (progressBar) { progressBar.style.width = pct + '%'; }
  }

  // ---- answers ------------------------------------------------------------
  var optionButtons = document.querySelectorAll('.cn-quiz-option[data-dim]');
  for (var b = 0; b < optionButtons.length; b++) {
    optionButtons[b].addEventListener('click', function () {
      var dim = this.getAttribute('data-dim');
      var val = this.getAttribute('data-val');
      var tags = (this.getAttribute('data-tags') || '').toLowerCase()
        .split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      var mode = this.getAttribute('data-mode') || '';

      var siblings = document.querySelectorAll('.cn-quiz-option[data-dim="' + dim + '"]');
      for (var s = 0; s < siblings.length; s++) { siblings[s].classList.remove('is-selected'); }
      this.classList.add('is-selected');

      state.answers[dim] = val;
      state.tagSets[dim] = tags;
      if (dim === 'space' && mode) { state.wantMode = mode; }

      setTimeout(function () {
        if (state.currentStep < state.totalSteps) {
          state.currentStep++;
          showStep(state.currentStep);
          updateProgress(state.currentStep);
        } else {
          runQuiz();
        }
      }, 300);
    });
  }

  // ---- scoring ------------------------------------------------------------
  function scoreProduct(product) {
    var tags = tagList(product);
    var score = 0;
    var dims = ['palette', 'style', 'mood', 'space'];

    for (var d = 0; d < dims.length; d++) {
      var dim = dims[d];
      var wanted = state.tagSets[dim] || [];
      var weight = WEIGHTS[dim] || 1;
      for (var w = 0; w < wanted.length; w++) {
        if (tags.indexOf(wanted[w]) !== -1) { score += weight; }
      }
    }

    if (state.wantMode && product.m && product.m === state.wantMode) {
      score += MODE_BONUS;
    }
    return score;
  }

  // ---- run ----------------------------------------------------------------
  function runQuiz() {
    showStep('loading');
    updateProgress(state.totalSteps + 1);

    setTimeout(function () {
      var scored = [];
      for (var i = 0; i < PRODUCTS.length; i++) {
        scored.push({ p: PRODUCTS[i], s: scoreProduct(PRODUCTS[i]), i: i });
      }
      scored.sort(function (a, b) {
        if (b.s !== a.s) { return b.s - a.s; }
        return a.i - b.i;
      });

      var matched = [];
      for (var j = 0; j < scored.length && matched.length < RESULT_COUNT; j++) {
        if (scored[j].s > 0) { matched.push(scored[j].p); }
      }
      for (var k = 0; k < scored.length && matched.length < RESULT_COUNT; k++) {
        if (matched.indexOf(scored[k].p) === -1) { matched.push(scored[k].p); }
      }

      renderResults(matched);
    }, 550);
  }

  // ---- render -------------------------------------------------------------
  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : String(str);
    return d.innerHTML;
  }

  function cardHTML(p, imgClass, titleClass, metaClass) {
    var html = '<a href="' + esc(p.u) + '">';
    html += '<div class="' + imgClass + '">';
    if (p.i) {
      html += '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy" width="600" height="600">';
    }
    html += '</div>';
    html += '<span class="' + titleClass + '">' + esc(p.t) + '</span>';
    if (p.c) { html += '<span class="' + metaClass + '">' + esc(p.c) + '</span>'; }
    return html + '</a>';
  }

  function setAdvisory(el) {
    if (!el) { return; }
    if (state.answers.space === 'bathroom') {
      el.textContent = BATHROOM_NOTE;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function renderResults(products) {
    var html;

    // Preferred: the quiz section's own results block, on the page.
    if (gridEl && resultsEl) {
      html = '';
      for (var i = 0; i < products.length; i++) {
        html += cardHTML(products[i],
          'quiz-cta__product-img', 'quiz-cta__product-title', 'quiz-cta__product-meta')
          .replace('<a href=', '<a class="quiz-cta__product-card" href=');
      }
      gridEl.innerHTML = html;
      setAdvisory(advisoryEl);
      closeQuiz();
      resultsEl.style.display = 'block';
      resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    // Fallback: no section on this page, so show results inside the modal.
    if (modalGrid) {
      html = '';
      for (var j = 0; j < products.length; j++) {
        html += cardHTML(products[j], 'cnq-r-img', 'cnq-r-title', 'cnq-r-meta');
      }
      modalGrid.innerHTML = html;
      setAdvisory(modalAdvisory);
      showStep('results');
      updateProgress(state.totalSteps + 1);
    }
  }

  // ---- catalogue tabs (quiz section only) ---------------------------------
  (function catalogueTabs() {
    var tabs = document.querySelectorAll('.cnq-tab');
    var cards = document.querySelectorAll('.cnq-card');
    var grid = document.getElementById('cnqGrid');
    if (!tabs.length || !cards.length) { return; }

    var empty = document.createElement('p');
    empty.className = 'cnq-empty';
    empty.textContent = 'Nothing in this category yet.';
    empty.hidden = true;
    if (grid) { grid.appendChild(empty); }

    for (var t = 0; t < tabs.length; t++) {
      tabs[t].addEventListener('click', function () {
        var cat = this.getAttribute('data-cat');
        for (var i = 0; i < tabs.length; i++) {
          tabs[i].classList.remove('is-active');
          tabs[i].setAttribute('aria-selected', 'false');
        }
        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');

        var shown = 0;
        for (var c = 0; c < cards.length; c++) {
          var match = (cat === 'all') || (cards[c].getAttribute('data-cat') === cat);
          cards[c].hidden = !match;
          if (match) { shown++; }
        }
        empty.hidden = shown > 0;
      });
    }
  })();

})();